import axios from '../axios';

function makeFilterQuery (key, value) {
  if (Array.isArray(value)) {
    value = value.join(',');
  }

  return `filter[${key}]=${value}`;
}

export class AnalyticsServer {
  static load (params) {
    const query = Object.keys(params)
      .map(key => makeFilterQuery(key, params[key]));

    query.push('include=doorphones');

    return axios.get(`/analytics?${query.join('&')}`)
      .then(({ data }) => data);
  }

  static show (id) {
    axios.loading = true;
    return axios.get(`/analytics/${id}`)
      .then(({ data }) => data)
      .finally(() => {
        axios.loading = false;
      });
  }
}
